import React from 'react';
import PropTypes from 'prop-types';
import RadioSwitch from 'tradera-components/form-controls/radio-switch';

export const RadioSwitchFilter = ({
    filter = {},
    optionClasses = {},
    handleFilterChange,
    id,
    className
}) => {
    const { parameter, selectedValue, options } = filter;
    if (!options) {
        return null;
    }

    return (
        <div className="col-12 p-0">
            <RadioSwitch
                id={id}
                options={options}
                optionClasses={optionClasses}
                checked={selectedValue}
                handleOnChange={e => {
                    handleFilterChange(parameter, e);
                }}
                className={className}
            />
        </div>
    );
};

RadioSwitchFilter.propTypes = {
    filter: PropTypes.object,
    optionClasses: PropTypes.object,
    handleFilterChange: PropTypes.func,
    id: PropTypes.string.isRequired
};
